export const Countries = [ 
    {display: 'Afghanistan', id: 'AF'}, 
    {display: 'Åland Islands', id: 'AX'}, 
    {display: 'Albania', id: 'AL'}, 
    {display: 'Algeria', id: 'DZ'}, 
    {display: 'American Samoa', id: 'AS'}, 
    {display: 'AndorrA', id: 'AD'}, 
    {display: 'Angola', id: 'AO'}, 
    {display: 'Anguilla', id: 'AI'}, 
    {display: 'Antarctica', id: 'AQ'}, 
    {display: 'Antigua and Barbuda', id: 'AG'}, 
    {display: 'Argentina', id: 'AR'}, 
    {display: 'Armenia', id: 'AM'}, 
    {display: 'Aruba', id: 'AW'}, 
    {display: 'Australia', id: 'AU'}, 
    {display: 'Austria', id: 'AT'}, 
    {display: 'Azerbaijan', id: 'AZ'}, 
    {display: 'Bahamas', id: 'BS'}, 
    {display: 'Bahrain', id: 'BH'}, 
    {display: 'Bangladesh', id: 'BD'}, 
    {display: 'Barbados', id: 'BB'}, 
    {display: 'Belarus', id: 'BY'}, 
    {display: 'Belgium', id: 'BE'}, 
    {display: 'Belize', id: 'BZ'}, 
    {display: 'Benin', id: 'BJ'}, 
    {display: 'Bermuda', id: 'BM'}, 
    {display: 'Bhutan', id: 'BT'}, 
    {display: 'Bolivia', id: 'BO'}, 
    {display: 'Bosnia and Herzegovina', id: 'BA'}, 
    {display: 'Botswana', id: 'BW'}, 
    {display: 'Bouvet Island', id: 'BV'}, 
    {display: 'Brazil', id: 'BR'}, 
    {display: 'British Indian Ocean Territory', id: 'IO'}, 
    {display: 'Brunei Darussalam', id: 'BN'}, 
    {display: 'Bulgaria', id: 'BG'}, 
    {display: 'Burkina Faso', id: 'BF'}, 
    {display: 'Burundi', id: 'BI'}, 
    {display: 'Cambodia', id: 'KH'}, 
    {display: 'Cameroon', id: 'CM'}, 
    {display: 'Canada', id: 'CA'}, 
    {display: 'Cape Verde', id: 'CV'}, 
    {display: 'Cayman Islands', id: 'KY'}, 
    {display: 'Central African Republic', id: 'CF'}, 
    {display: 'Chad', id: 'TD'}, 
    {display: 'Chile', id: 'CL'}, 
    {display: 'China', id: 'CN'}, 
    {display: 'Christmas Island', id: 'CX'}, 
    {display: 'Cocos (Keeling) Islands', id: 'CC'}, 
    {display: 'Colombia', id: 'CO'}, 
    {display: 'Comoros', id: 'KM'}, 
    {display: 'Congo', id: 'CG'}, 
    {display: 'Congo, The Democratic Republic of the', id: 'CD'}, 
    {display: 'Cook Islands', id: 'CK'}, 
    {display: 'Costa Rica', id: 'CR'}, 
    {display: 'Cote D\'Ivoire', id: 'CI'}, 
    {display: 'Croatia', id: 'HR'}, 
    {display: 'Cuba', id: 'CU'}, 
    {display: 'Cyprus', id: 'CY'}, 
    {display: 'Czech Republic', id: 'CZ'}, 
    {display: 'Denmark', id: 'DK'}, 
    {display: 'Djibouti', id: 'DJ'}, 
    {display: 'Dominica', id: 'DM'}, 
    {display: 'Dominican Republic', id: 'DO'}, 
    {display: 'Ecuador', id: 'EC'}, 
    {display: 'Egypt', id: 'EG'}, 
    {display: 'El Salvador', id: 'SV'}, 
    {display: 'Equatorial Guinea', id: 'GQ'}, 
    {display: 'Eritrea', id: 'ER'}, 
    {display: 'Estonia', id: 'EE'}, 
    {display: 'Ethiopia', id: 'ET'}, 
    {display: 'Falkland Islands (Malvinas)', id: 'FK'}, 
    {display: 'Faroe Islands', id: 'FO'}, 
    {display: 'Fiji', id: 'FJ'}, 
    {display: 'Finland', id: 'FI'}, 
    {display: 'France', id: 'FR'}, 
    {display: 'French Guiana', id: 'GF'}, 
    {display: 'French Polynesia', id: 'PF'}, 
    {display: 'French Southern Territories', id: 'TF'}, 
    {display: 'Gabon', id: 'GA'}, 
    {display: 'Gambia', id: 'GM'}, 
    {display: 'Georgia', id: 'GE'}, 
    {display: 'Germany', id: 'DE'}, 
    {display: 'Ghana', id: 'GH'}, 
    {display: 'Gibraltar', id: 'GI'}, 
    {display: 'Greece', id: 'GR'}, 
    {display: 'Greenland', id: 'GL'}, 
    {display: 'Grenada', id: 'GD'}, 
    {display: 'Guadeloupe', id: 'GP'}, 
    {display: 'Guam', id: 'GU'}, 
    {display: 'Guatemala', id: 'GT'}, 
    {display: 'Guernsey', id: 'GG'}, 
    {display: 'Guinea', id: 'GN'}, 
    {display: 'Guinea-Bissau', id: 'GW'}, 
    {display: 'Guyana', id: 'GY'}, 
    {display: 'Haiti', id: 'HT'}, 
    {display: 'Heard Island and Mcdonald Islands', id: 'HM'}, 
    {display: 'Holy See (Vatican City State)', id: 'VA'}, 
    {display: 'Honduras', id: 'HN'}, 
    {display: 'Hong Kong', id: 'HK'}, 
    {display: 'Hungary', id: 'HU'}, 
    {display: 'Iceland', id: 'IS'}, 
    {display: 'India', id: 'IN'}, 
    {display: 'Indonesia', id: 'ID'}, 
    {display: 'Iran, Islamic Republic Of', id: 'IR'}, 
    {display: 'Iraq', id: 'IQ'}, 
    {display: 'Ireland', id: 'IE'}, 
    {display: 'Isle of Man', id: 'IM'}, 
    {display: 'Israel', id: 'IL'}, 
    {display: 'Italy', id: 'IT'}, 
    {display: 'Jamaica', id: 'JM'}, 
    {display: 'Japan', id: 'JP'}, 
    {display: 'Jersey', id: 'JE'}, 
    {display: 'Jordan', id: 'JO'}, 
    {display: 'Kazakhstan', id: 'KZ'}, 
    {display: 'Kenya', id: 'KE'}, 
    {display: 'Kiribati', id: 'KI'}, 
    {display: 'Korea, Democratic People\'S Republic of', id: 'KP'}, 
    {display: 'Korea, Republic of', id: 'KR'}, 
    {display: 'Kuwait', id: 'KW'}, 
    {display: 'Kyrgyzstan', id: 'KG'}, 
    {display: 'Lao People\'S Democratic Republic', id: 'LA'}, 
    {display: 'Latvia', id: 'LV'}, 
    {display: 'Lebanon', id: 'LB'}, 
    {display: 'Lesotho', id: 'LS'}, 
    {display: 'Liberia', id: 'LR'}, 
    {display: 'Libyan Arab Jamahiriya', id: 'LY'}, 
    {display: 'Liechtenstein', id: 'LI'}, 
    {display: 'Lithuania', id: 'LT'}, 
    {display: 'Luxembourg', id: 'LU'}, 
    {display: 'Macao', id: 'MO'}, 
    {display: 'Macedonia, The Former Yugoslav Republic of', id: 'MK'}, 
    {display: 'Madagascar', id: 'MG'}, 
    {display: 'Malawi', id: 'MW'}, 
    {display: 'Malaysia', id: 'MY'}, 
    {display: 'Maldives', id: 'MV'}, 
    {display: 'Mali', id: 'ML'}, 
    {display: 'Malta', id: 'MT'}, 
    {display: 'Marshall Islands', id: 'MH'}, 
    {display: 'Martinique', id: 'MQ'}, 
    {display: 'Mauritania', id: 'MR'}, 
    {display: 'Mauritius', id: 'MU'}, 
    {display: 'Mayotte', id: 'YT'}, 
    {display: 'Mexico', id: 'MX'}, 
    {display: 'Micronesia, Federated States of', id: 'FM'}, 
    {display: 'Moldova, Republic of', id: 'MD'}, 
    {display: 'Monaco', id: 'MC'}, 
    {display: 'Mongolia', id: 'MN'}, 
    {display: 'Montserrat', id: 'MS'}, 
    {display: 'Morocco', id: 'MA'}, 
    {display: 'Mozambique', id: 'MZ'}, 
    {display: 'Myanmar', id: 'MM'}, 
    {display: 'Namibia', id: 'NA'}, 
    {display: 'Nauru', id: 'NR'}, 
    {display: 'Nepal', id: 'NP'}, 
    {display: 'Netherlands', id: 'NL'}, 
    {display: 'Netherlands Antilles', id: 'AN'}, 
    {display: 'New Caledonia', id: 'NC'}, 
    {display: 'New Zealand', id: 'NZ'}, 
    {display: 'Nicaragua', id: 'NI'}, 
    {display: 'Niger', id: 'NE'}, 
    {display: 'Nigeria', id: 'NG'}, 
    {display: 'Niue', id: 'NU'}, 
    {display: 'Norfolk Island', id: 'NF'}, 
    {display: 'Northern Mariana Islands', id: 'MP'}, 
    {display: 'Norway', id: 'NO'}, 
    {display: 'Oman', id: 'OM'}, 
    {display: 'Pakistan', id: 'PK'}, 
    {display: 'Palau', id: 'PW'}, 
    {display: 'Palestinian Territory, Occupied', id: 'PS'}, 
    {display: 'Panama', id: 'PA'}, 
    {display: 'Papua New Guinea', id: 'PG'}, 
    {display: 'Paraguay', id: 'PY'}, 
    {display: 'Peru', id: 'PE'}, 
    {display: 'Philippines', id: 'PH'}, 
    {display: 'Pitcairn', id: 'PN'}, 
    {display: 'Poland', id: 'PL'}, 
    {display: 'Portugal', id: 'PT'}, 
    {display: 'Puerto Rico', id: 'PR'}, 
    {display: 'Qatar', id: 'QA'}, 
    {display: 'Reunion', id: 'RE'}, 
    {display: 'Romania', id: 'RO'}, 
    {display: 'Russian Federation', id: 'RU'}, 
    {display: 'RWANDA', id: 'RW'}, 
    {display: 'Saint Helena', id: 'SH'}, 
    {display: 'Saint Kitts and Nevis', id: 'KN'}, 
    {display: 'Saint Lucia', id: 'LC'}, 
    {display: 'Saint Pierre and Miquelon', id: 'PM'}, 
    {display: 'Saint Vincent and the Grenadines', id: 'VC'}, 
    {display: 'Samoa', id: 'WS'}, 
    {display: 'San Marino', id: 'SM'}, 
    {display: 'Sao Tome and Principe', id: 'ST'}, 
    {display: 'Saudi Arabia', id: 'SA'}, 
    {display: 'Senegal', id: 'SN'}, 
    {display: 'Serbia and Montenegro', id: 'CS'}, 
    {display: 'Seychelles', id: 'SC'}, 
    {display: 'Sierra Leone', id: 'SL'}, 
    {display: 'Singapore', id: 'SG'}, 
    {display: 'Slovakia', id: 'SK'}, 
    {display: 'Slovenia', id: 'SI'}, 
    {display: 'Solomon Islands', id: 'SB'}, 
    {display: 'Somalia', id: 'SO'}, 
    {display: 'South Africa', id: 'ZA'}, 
    {display: 'South Georgia and the South Sandwich Islands', id: 'GS'}, 
    {display: 'Spain', id: 'ES'}, 
    {display: 'Sri Lanka', id: 'LK'}, 
    {display: 'Sudan', id: 'SD'}, 
    {display: 'Suriname', id: 'SR'}, 
    {display: 'Svalbard and Jan Mayen', id: 'SJ'}, 
    {display: 'Swaziland', id: 'SZ'}, 
    {display: 'Sweden', id: 'SE'}, 
    {display: 'Switzerland', id: 'CH'}, 
    {display: 'Syrian Arab Republic', id: 'SY'}, 
    {display: 'Taiwan, Province of China', id: 'TW'}, 
    {display: 'Tajikistan', id: 'TJ'}, 
    {display: 'Tanzania, United Republic of', id: 'TZ'}, 
    {display: 'Thailand', id: 'TH'}, 
    {display: 'Timor-Leste', id: 'TL'}, 
    {display: 'Togo', id: 'TG'}, 
    {display: 'Tokelau', id: 'TK'}, 
    {display: 'Tonga', id: 'TO'}, 
    {display: 'Trinidad and Tobago', id: 'TT'}, 
    {display: 'Tunisia', id: 'TN'}, 
    {display: 'Turkey', id: 'TR'}, 
    {display: 'Turkmenistan', id: 'TM'}, 
    {display: 'Turks and Caicos Islands', id: 'TC'}, 
    {display: 'Tuvalu', id: 'TV'}, 
    {display: 'Uganda', id: 'UG'}, 
    {display: 'Ukraine', id: 'UA'}, 
    {display: 'United Arab Emirates', id: 'AE'}, 
    {display: 'United Kingdom', id: 'GB'}, 
    {display: 'United States', id: 'US'}, 
    {display: 'United States Minor Outlying Islands', id: 'UM'}, 
    {display: 'Uruguay', id: 'UY'}, 
    {display: 'Uzbekistan', id: 'UZ'}, 
    {display: 'Vanuatu', id: 'VU'}, 
    {display: 'Venezuela', id: 'VE'}, 
    {display: 'Viet Nam', id: 'VN'}, 
    {display: 'Virgin Islands, British', id: 'VG'}, 
    {display: 'Virgin Islands, U.S.', id: 'VI'}, 
    {display: 'Wallis and Futuna', id: 'WF'}, 
    {display: 'Western Sahara', id: 'EH'}, 
    {display: 'Yemen', id: 'YE'}, 
    {display: 'Zambia', id: 'ZM'}, 
    {display: 'Zimbabwe', id: 'ZW'} 
  ]